import { useSchema } from 'domain/ClientService';

export enum AdvisoryOptionTypesEnum {
    CATEGORY = 'AdvisoryCategoryType',
    INSTITUTE = 'AdvisoryInstituteType',
    STRATEGY = 'AdvisoryStrategyType',
    REAL_STATE_PROPERTY = 'advisoryRealEstateType',
  }

export const useGetListItemsByKey = (keys: string[]) => {
    const { errorInSchemaLists, statusOfSchemaLists, dataLists } = useSchema();

    const advisorySchemaList = dataLists?.length ? dataLists?.filter((list) => keys?.includes(list?.listKey))?.map((list) => ({
        key: list?.listKey,
        data: list?.listItems?.map((d: { id: number; label: string; }) => ({ value: d?.id, label: d?.label })),
        error: errorInSchemaLists || null,
        status: statusOfSchemaLists || null,
    })) : keys?.map((key) => ({
        key,
        data: [],
        error: errorInSchemaLists || null,
        status: statusOfSchemaLists || null,
    }));

    return {
        advisoryOptions: advisorySchemaList,
    };
};
